import * as THREE from 'three';
import type { GameState } from '../state/types';
import { createDrone } from './drone';
import { createPickupTruck } from './pickupTruck';

export function createVehicleMeshes(scene: THREE.Scene, state: GameState): void {
  // Outer group: driven by sim (position + rotation.y). Forward = +X.
  const truckGroup = new THREE.Group();
  truckGroup.position.set(state.truck.x, 0.1, state.truck.z);

  const truckVisual = createPickupTruck(0xef4444);
  // Model length is along Z with front at -Z; map front to +X for the sim.
  truckVisual.rotation.y = -Math.PI / 2;
  truckVisual.scale.setScalar(0.65);
  truckGroup.add(truckVisual);

  scene.add(truckGroup);
  state.truck.mesh = truckGroup;

  const droneGroup = new THREE.Group();
  droneGroup.position.set(state.drone.x, state.drone.y, state.drone.z);

  const { group: droneVisual, rotors, cameraLens } = createDrone();
  droneGroup.add(droneVisual);
  state.drone.rotors.push(...rotors);
  state.drone.cameraLens = cameraLens;

  scene.add(droneGroup);
  state.drone.mesh = droneGroup;
}
